import Image from 'next/image';

export const HowToMeasure2 = ({ image }: { image: string }) => {
  return (
    <div className='my-[60px] flex flex-col items-center gap-[30px] lg_my-[80px] lg_flex-row lg_items-start lg_gap-[80px]'>
      <Image
        src={image}
        alt='measure-2'
        width={194}
        height={595}
      />
      <div className='flex flex-col gap-[30px] lg_gap-[40px]'>
        {[
          {
            title: '1.Chest',
            description:
              'Put on socks that you will most likely use with the footwear. It is better to take the measurements during the afternoon or evening.',
          },
          {
            title: '2.Waist',
            description:
              'Place your hands on your hips and bend to the side. The indent on your side as you bend is your natural waist. Measure the total circumference at this point.',
          },
          {
            title: '3.Hip',
            description: `Stand with your feet 6" apart. Measure the total circumference at the fullest point of your hip.`,
          },
          {
            title: '4.Inseam',
            description: `Stand with your feet 6" apart. Measure from the top of the leg/crotch to below the ankle. Or take a pair of pants that fit well and take the same measurement.`,
          },
        ].map(item => (
          <HowToMeasure2Item
            title={item.title}
            description={item.description}
            key={item.title}
          />
        ))}
      </div>
    </div>
  );
};

export const HowToMeasure2Item = ({ title, description }: { title: string; description: string }) => {
  return (
    <div>
      <h4 className='mb-[10px] font-roboto-medium text-[18px] font-medium leading-[21px]'>{title}</h4>
      <div className='font-roboto-light text-[16px] font-light leading-[26px]'>{description}</div>
    </div>
  );
};
